export default __webpack_public_path__ + "a37d1155faf22651e5d208e7cea49f02.png";